<template>
  <div>
    <div class="d-sm-flex justify-between mb-5">
      <v-btn
        v-if="filter != ''"
        elevation="0"
        height="43"
        class="font-weight-bold text-uppercase shadow-none btn-default btn-outline-default py-2 px-6 me-2 mb-sm-0 mb-2"
        color="transparent"
        small
        >Filter: {{ filter }}</v-btn
      >
      <div class="d-flex ms-auto">
        <v-menu transition="slide-y-transition" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              elevation="0"
              height="43"
              class="font-weight-bold text-uppercase btn-default btn-outline-default shadow-none py-2 px-6 me-2"
              color="transparent"
              small
            >
              Filters
              <v-icon>ni ni-bold-down text-xs ms-1</v-icon>
            </v-btn>
          </template>

          <v-list class="py-0">
            <v-list-item
              class="list-item-hover-active py-2"
              @click="filter = 'Eingelöst'"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-title
                  class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                >
                  Status: Eingelöst
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              class="list-item-hover-active pb-2"
              @click="filter = 'Nicht eingelöst'"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-title
                  class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                >
                  Status: Nicht eingelöst
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <hr class="horizontal dark" />
            <v-list-item
              class="list-item-hover-active py-2"
              @click="filter = ''"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-title
                  class="text-danger ls-0 font-weight-600 mb-0"
                >
                  Filter entfernen
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          elevation="0"
          height="43"
          class="font-weight-bold text-uppercase btn-default btn-outline-default shadow-none py-2 px-6 me-2"
          color="transparent"
          small
          @click="csvExportEntries(event)"
        >
          <v-icon>ni ni-archive-2 me-1</v-icon>
          Export CSV
        </v-btn>
        <v-menu transition="slide-y-transition" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              elevation="0"
              height="43"
              class="font-weight-bold text-uppercase btn-default btn-outline-default shadow-none py-2 px-6 me-2"
              color="transparent"
              small
            >
              Nur Codes (CSV)
              <v-icon>ni ni-bold-down text-xs ms-1</v-icon>
            </v-btn>
          </template>
          <v-list class="py-0">
            <v-list-item class="list-item-hover-active py-2" @click="csvExportCodes(event, false)">
              <v-list-item-content class="pa-0">
                <v-list-item-title class="text-body-2 ls-0 text-typo font-weight-600 mb-0">
                  Gültige Tickets
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="list-item-hover-active py-2" @click="csvExportCodes(event, true)">
              <v-list-item-content class="pa-0">
                <v-list-item-title class="text-body-2 ls-0 text-typo font-weight-600 mb-0">
                  Alle Tickets
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    <v-card class="card-shadow border-radius-xl">
      <v-overlay :value="updatingEvents" absolute>
        <v-progress-circular
          indeterminate
          size="64"
          color="primary"
        ></v-progress-circular>
      </v-overlay>
      <div class="card-header-padding">
        <v-row class="mt-0 ml-1" justify="space-between">
          <h5 class="font-weight-bolder text-h5 text-typo">
            {{ entriesArray.length }} Anmeldungen
          </h5>
          <div class="mr-2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  @click="refreshEvent"
                  v-bind="attrs"
                  v-on="on"
                  class="material-icons-round text-primary ms-auto"
                  size="30"
                >
                  refresh
                </v-icon>
              </template>
              <span>Aktualisieren</span>
            </v-tooltip>
          </div>
        </v-row>
        <!-- <h5 class="font-weight-bold text-h5 text-typo mb-0">
          {{ event.entries.length }} Anmeldungen
        </h5> -->
      </div>

      <v-card-text class="px-0 py-0">
        <v-data-table
          :headers="headers"
          :items="filteredEntries"
          :search="search"
          :sort-by="['created']"
          :sort-desc="[true]"
          class="table"
          :page.sync="page"
          hide-default-footer
          @page-count="pageCount = $event"
          :items-per-page="itemsPerPage"
          mobile-breakpoint="0"
        >
          <template v-slot:top>
            <v-toolbar flat height="80">
              <v-row>
                <v-col cols="12" md="5">
                  <v-text-field
                    hide-details
                    class="input-style font-size-input text-light-input placeholder-light input-icon"
                    dense
                    flat
                    filled
                    solo
                    height="43"
                    v-model="search"
                    placeholder="Suche"
                  >
                    <template slot="prepend-inner">
                      <v-icon
                        color="#adb5bd"
                        size="16"
                        class="material-icons-round mt-n2"
                        >search</v-icon
                      >
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <v-spacer></v-spacer>

              <v-dialog v-model="dialog" max-width="900px" scrollable>
                <v-card class="card-shadow border-radius-xl">
                  <!-- Header Section -->
                  <div class="card-header-padding card-border-bottom" style="background: linear-gradient(87deg, #5e72e4 0, #825ee4 100%);">
                    <div class="d-flex align-center justify-space-between">
                      <div>
                        <span class="font-weight-bold text-h5 text-white mb-0 d-block">{{
                          formTitle
                        }}</span>
                        <span class="text-white text-caption mt-1 d-block" v-if="getInvoiceNumber(editedItem) !== '-'">
                          Rechnungsnummer: {{ getInvoiceNumber(editedItem) }}
                        </span>
                      </div>
                      <v-chip
                        :color="getStatusColor(editedItem)"
                        dark
                        small
                        class="font-weight-bold"
                      >
                        {{ getPaymentStatus(editedItem) }}
                      </v-chip>
                    </div>
                  </div>

                  <v-card-text class="card-padding">
                    <v-container class="px-0">
                      <!-- Personendaten Section -->
                      <div class="mb-6">
                        <h6 class="text-h6 text-typo mb-4 d-flex align-center">
                          <v-icon class="material-icons-round me-2" color="primary">person</v-icon>
                          Personendaten
                        </h6>
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-text-field
                              :value="getPaymentFirstName(editedItem)"
                              hide-details
                              disabled
                              class="input-style font-size-input text-light-input placeholder-light input-icon"
                              dense
                              flat
                              outlined
                              height="43"
                              placeholder="Vorname"
                              label="Vorname"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              :value="getPaymentLastName(editedItem)"
                              hide-details
                              disabled
                              class="input-style font-size-input text-light-input placeholder-light input-icon"
                              dense
                              flat
                              outlined
                              height="43"
                              placeholder="Nachname"
                              label="Nachname"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="editedEmail"
                              hide-details
                              :disabled="savingEmail"
                              class="input-style font-size-input text-light-input placeholder-light input-icon"
                              dense
                              flat
                              outlined
                              height="43"
                              placeholder="E-Mail-Adresse"
                              label="E-Mail-Adresse"
                              @blur="saveEmail"
                              @keyup.enter="saveEmail"
                            >
                              <template v-slot:append-outer>
                                <v-btn
                                  v-if="editedEmail && editedEmail !== getOriginalEmail(editedItem)"
                                  @click="saveEmail"
                                  :loading="savingEmail"
                                  icon
                                  small
                                  color="primary"
                                >
                                  <v-icon small class="material-icons-round">save</v-icon>
                                </v-btn>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              :value="getPaymentStreet(editedItem)"
                              hide-details
                              disabled
                              class="input-style font-size-input text-light-input placeholder-light input-icon"
                              dense
                              flat
                              outlined
                              height="43"
                              placeholder="Straße"
                              label="Straße"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              :value="getPaymentNumber(editedItem)"
                              hide-details
                              disabled
                              class="input-style font-size-input text-light-input placeholder-light input-icon"
                              dense
                              flat
                              outlined
                              height="43"
                              placeholder="Hausnummer"
                              label="Hausnummer"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              :value="getPaymentZip(editedItem)"
                              hide-details
                              disabled
                              class="input-style font-size-input text-light-input placeholder-light input-icon"
                              dense
                              flat
                              outlined
                              height="43"
                              placeholder="Postleitzahl"
                              label="Postleitzahl"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              :value="getPaymentCity(editedItem)"
                              hide-details
                              disabled
                              class="input-style font-size-input text-light-input placeholder-light input-icon"
                              dense
                              flat
                              outlined
                              height="43"
                              placeholder="Ort"
                              label="Ort"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </div>

                      <!-- Rechnungs- und Zahlungsinformationen Section -->
                      <div class="mb-6">
                        <h6 class="text-h6 text-typo mb-4 d-flex align-center">
                          <v-icon class="material-icons-round me-2" color="primary">payment</v-icon>
                          Rechnungs- und Zahlungsinformationen
                        </h6>
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-text-field
                              :value="getInvoiceNumber(editedItem)"
                              hide-details
                              disabled
                              class="input-style font-size-input text-light-input placeholder-light input-icon"
                              dense
                              flat
                              outlined
                              height="43"
                              label="Rechnungsnummer"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              :value="getPaymentMethod(editedItem)"
                              hide-details
                              disabled
                              class="input-style font-size-input text-light-input placeholder-light input-icon"
                              dense
                              flat
                              outlined
                              height="43"
                              label="Zahlungsart"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              :value="getSource(editedItem)"
                              hide-details
                              disabled
                              class="input-style font-size-input text-light-input placeholder-light input-icon"
                              dense
                              flat
                              outlined
                              height="43"
                              label="Quelle"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              :value="getPaymentStatus(editedItem)"
                              hide-details
                              disabled
                              class="input-style font-size-input text-light-input placeholder-light input-icon"
                              dense
                              flat
                              outlined
                              height="43"
                              label="Zahlungsstatus"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </div>
                    </v-container>
                  </v-card-text>

                  <!-- Aktionen Section -->
                  <v-divider></v-divider>
                  <v-card-actions class="card-padding">
                    <v-row>
                      <v-col cols="12" class="pb-2">
                        <div class="d-flex flex-wrap">
                          <v-btn
                            v-if="getInvoiceNumber(editedItem) !== '-'"
                            @click="downloadInvoiceModal(editedItem)"
                            elevation="0"
                            :ripple="false"
                            height="43"
                            class="font-weight-normal text-capitalize btn-ls btn-primary bg-gradient-info py-3 px-6 mr-2 mb-2"
                          >
                            <v-icon class="material-icons-round me-2" size="18">download</v-icon>
                            Rechnung herunterladen
                          </v-btn>
                          <v-btn
                            @click="
                              emailResended == editedItem._id
                                ? null
                                : resendEmail(editedItem)
                            "
                            elevation="0"
                            :ripple="false"
                            height="43"
                            :loading="updating"
                            :disabled="isEmailInvalid(editedItem)"
                            class="font-weight-normal text-capitalize btn-ls btn-primary py-3 px-6 mr-2 mb-2"
                            :class="
                              emailResended == editedItem._id
                                ? 'bg-gradient-success'
                                : 'bg-gradient-primary'
                            "
                          >
                            <v-icon class="material-icons-round me-2" size="18">{{ emailResended == editedItem._id ? 'check_circle' : 'email' }}</v-icon>
                            {{
                              emailResended == editedItem._id
                                ? "E-Mail gesendet!"
                                : "Ticket-E-Mail erneut senden"
                            }}
                          </v-btn>
                        </div>
                      </v-col>
                      <v-col cols="12" class="d-flex justify-end pt-2">
                        <v-btn
                          @click="close"
                          elevation="0"
                          :ripple="false"
                          height="43"
                          class="font-weight-normal text-capitalize btn-ls btn-outline-secondary bg-transparent py-3 px-6"
                        >
                          schließen
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="showParticipantsDialog" max-width="600px">
                <v-card
                  class="card-shadow card-padding border-radius-xl"
                  v-if="!editedItem.participant_data"
                >
                  <div class="card-header-padding card-border-bottom">
                    <span class="font-weight-bold text-h5 text-typo mb-0"
                      >Teilnehmerdaten</span
                    >
                  </div>
                  <v-card-text class="card-padding">
                    <v-container class="px-0">
                      <v-row>
                        <v-col cols="6">
                          <v-text-field
                            v-model="editedItem.firstname"
                            hide-details
                            disabled
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Vorname"
                            label="Vorname"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="editedItem.lastname"
                            hide-details
                            disabled
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Nachname"
                            label="Nachname"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="editedItem.email"
                            hide-details
                            disabled
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="E-Mail-Adresse"
                            label="E-Mail-Adresse"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="editedItem.street"
                            hide-details
                            disabled
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Straße"
                            label="Straße"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="6">
                          <v-text-field
                            v-model="editedItem.zip"
                            hide-details
                            disabled
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Postleitzahl"
                            label="Postleitzahl"
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="editedItem.city"
                            hide-details
                            disabled
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Ort"
                            label="Ort"
                          ></v-text-field>
                        </v-col>
                        <!-- <v-col cols="6">
                          <v-btn
                            @click="
                              emailResended ? null : resendEmail(editedItem)
                            "
                            elevation="0"
                            :ripple="false"
                            height="43"
                            class="
                              font-weight-normal
                              text-capitalize
                              btn-ls btn-primary
                              py-3
                              px-6
                            "
                            :class="
                              emailResended == editedItem._id
                                ? 'bg-gradient-success'
                                : 'bg-gradient-info'
                            "
                            >{{
                              emailResended == editedItem._id
                                ? "Ticket-E-Mail gesendet!"
                                : "Ticket-E-Mail erneut senden"
                            }}</v-btn
                          >
                        </v-col> -->
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions class="pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                      @click="close"
                      elevation="0"
                      :ripple="false"
                      height="43"
                      class="font-weight-normal text-capitalize btn-ls bg-transparent btn-outline-secondary py-3 px-6"
                      >schließen</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
                <v-card class="card-shadow border-radius-xl" v-else>
                  <div class="card-header-padding card-border-bottom">
                    <span class="font-weight-bold text-h5 text-typo mb-0"
                      >Angemeldeter Teilnehmer</span
                    >
                  </div>
                  <v-card-text class="card-padding">
                    <v-container class="px-0">
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            v-model="editedItem.participant_data.name"
                            hide-details
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Name"
                            label="Name"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                          <v-text-field
                            v-model="editedItem.participant_data.street"
                            hide-details
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Straße"
                            label="Straße"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="6">
                          <v-text-field
                            v-model="editedItem.participant_data.zipcode"
                            hide-details
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Postleitzahl"
                            label="Postleitzahl"
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="editedItem.participant_data.city"
                            hide-details
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Ort"
                            label="Ort"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions class="card-padding d-flex justify-end">
                    <v-btn
                      @click="save"
                      elevation="0"
                      :ripple="false"
                      :disabled="saving"
                      :loading="saving"
                      height="43"
                      class="font-weight-normal text-capitalize btn-ls btn-primary bg-gradient-primary py-3 px-6"
                      >speichern</v-btn
                    >
                    <v-btn
                      @click="close"
                      elevation="0"
                      :ripple="false"
                      :disabled="saving"
                      height="43"
                      class="font-weight-normal text-capitalize btn-ls btn-outline-secondary bg-transparent py-3 px-6"
                      >schließen</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="dialogNoInvoice" max-width="500px">
                <v-card class="card-shadow card-padding border-radius-xl">
                  <v-card-title class="pt-0 text-h5 text-typo justify-center"
                    >Keine Rechnung vorhanden</v-card-title
                  >
                  <v-card-actions class="pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                      @click="closeNoInvoice"
                      elevation="0"
                      :ripple="false"
                      height="43"
                      class="font-weight-normal text-capitalize btn-ls bg-transparent btn-outline-secondary py-3 px-6"
                      >schließen</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:item.firstname="{ item }">
            <div class="d-flex align-center ms-2">
              <span class="text-sm font-weight-normal text-body">
                {{ getParticipantName(item) }}
              </span>
            </div>
          </template>

          <template v-slot:item.email="{ item }">
            <span class="text-sm font-weight-normal text-body">
              {{ item.email }}
            </span>
          </template>

          <template v-slot:item.age="{ item }">
            <span class="text-sm font-weight-normal text-body">
              {{ item.age }}
            </span>
          </template>

          <template v-slot:item.salary="{ item }">
            <span class="text-sm font-weight-normal text-body">
              {{ item.salary }}
            </span>
          </template>

          <template v-slot:item.redeemed="{ item }">
            <div class="d-flex align-center" style="max-width: 50px">
              <v-btn
                @click="updateRedeemed(item)"
                :ripple="false"
                icon
                outlined
                rounded
                width="25px"
                height="25px"
                class="me-2"
                :class="item.redeemed ? 'border-success' : 'border-danger'"
              >
                <v-icon
                  size="8"
                  :class="item.redeemed ? 'text-success' : 'text-danger'"
                >
                  {{ item.redeemed ? "fas fa-check" : "fas fa-times" }}
                </v-icon>
              </v-btn>
              <span class="text-body text-xs">{{ item.status }}</span>
            </div>
          </template>

          <template v-slot:item.canceled="{ item }">
            <div class="d-flex align-center" style="max-width: 50px">
              <v-btn
                :ripple="false"
                icon
                outlined
                rounded
                disabled
                width="25px"
                height="25px"
                class="me-2"
                :class="item.canceled ? 'border-success' : 'border-danger'"
              >
                <v-icon
                  size="8"
                  :class="item.canceled ? 'text-success' : 'text-danger'"
                >
                  {{ item.canceled ? "fas fa-check" : "fas fa-times" }}
                </v-icon>
              </v-btn>
            </div>
          </template>

          <template v-slot:item.created="{ item }">
            <span class="text-sm text-body">
              {{ formatDate(item.created) }}
            </span>
          </template>

          <template v-slot:item.email_verified="{ item }">
            <div class="d-flex align-center">
              <v-btn
                :ripple="false"
                icon
                outlined
                rounded
                width="25px"
                height="25px"
                class="me-2"
                :class="
                  item.email_verified ? 'border-success' : 'border-default'
                "
              >
                <v-icon
                  size="8"
                  :class="item.email_verified ? 'text-success' : 'text-dark'"
                >
                  {{ item.email_verified ? "fas fa-check" : "fas fa-times" }}
                </v-icon>
              </v-btn>
              <span class="text-body text-xs">{{ item.status }}</span>
            </div>
          </template>

          <template v-slot:item.invoice_nr="{ item }">
            <span class="text-sm font-weight-normal text-body">
              {{ getInvoiceNumber(item) }}
            </span>
          </template>

          <template v-slot:item._id="{ item }">
            <v-btn
              @click="editItem(item)"
              icon
              elevation="0"
              :ripple="false"
              height="28"
              min-width="36"
              width="36"
              class="btn-ls me-2 my-2 rounded-sm"
              color="#67748e"
            >
              <v-icon size="25" class="material-icons-round">search</v-icon>
            </v-btn>

            <v-btn
              @click="showParticipants(item)"
              icon
              elevation="0"
              :ripple="false"
              height="28"
              min-width="36"
              width="36"
              class="btn-ls me-2 my-2 rounded-sm"
              color="#67748e"
            >
              <v-icon size="25" class="material-icons-round">person</v-icon>
            </v-btn>

            <!-- <v-btn
              @click="downloadInvoiceModal(item)"
              icon
              elevation="0"
              :ripple="false"
              height="28"
              min-width="36"
              width="36"
              class="btn-ls me-2 my-2 rounded-sm"
              color="#67748e"
            >
              <v-icon size="25" class="material-icons-round">download</v-icon>
            </v-btn> -->
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions class="card-padding">
        <v-row>
          <v-col cols="6" lg="3" class="d-flex align-center">
            <span class="text-body me-3 text-sm">Einträge pro Seite:</span>
            <v-text-field
              hide-details
              type="number"
              outlined
              min="-1"
              max="15"
              background-color="rgba(255,255,255,.9)"
              color="rgba(0,0,0,.6)"
              light
              :value="itemsPerPage"
              @input="itemsPerPage = parseInt($event, 10)"
              placeholder="Items per page"
              class="font-size-input placeholder-lighter text-color-light input-alternative input-focused-alternative input-icon"
            >
            </v-text-field>
          </v-col>
          <v-col cols="6" class="ml-auto d-flex justify-end">
            <v-pagination
              prev-icon="fa fa-angle-left"
              next-icon="fa fa-angle-right"
              class="pagination"
              color="#D81B60"
              v-model="page"
              :length="pageCount"
              circle
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import users from "./Users";
import coreData from "@/mixins/coreDataMixin";
import { mapGetters } from 'vuex';
import axiosAuth from "@/shared/configs/axios-auth";

export default {
  name: "paginated-tables",
  mixins: [coreData],
  data() {
    return {
      filter: "",
      dialogNoInvoice: false,
      showParticipantsDialog: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      dialog: false,
      dialogDelete: false,
      editingEmail: false,
      editedEmail: '',
      savingEmail: false,
      saving: false,
      users,
      search: "",
      editedIndex: -1,
      editedItem: {
        name: "",
        email: "",
        age: "",
        salary: "",
      },
      defaultItem: {
        name: "",
        email: "",
        age: "",
        salary: "",
      },
      headers: [
        {
          text: "Teilnehmer",
          align: "start",
          cellClass: "border-bottom",
          sortable: true,
          value: "firstname",
          class:
            "text-secondary font-weight-bolder opacity-7 border-bottom ps-6",
        },
        {
          text: "Eingelöst",
          value: "redeemed",

          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        // {
        //   text: "Storniert",
        //   value: "canceled",
        //   sortable: true,
        //   class: "text-secondary font-weight-bolder opacity-7",
        // },
        // {
        //   text: "Nachname",
        //   value: "lastname",
        //   class: "text-secondary font-weight-bolder opacity-7",
        // },
        {
          text: "Bestätigt",
          value: "email_verified",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Anmelder E-Mail",
          value: "email",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Rechnungsnummer",
          value: "invoice_nr",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Datum",
          value: "created",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Aktionen",
          value: "_id",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7",
        },
      ],
    };
  },
  methods: {
    refreshEvent() {
      if (this.event && this.event._id) {
        this.$store.dispatch('getEventByIdAdmin', this.event._id);
      }
    },
    editItem(item) {
      this.editedItem = item;
      this.editedEmail = this.getOriginalEmail(item);
      this.dialog = true;
    },
    showParticipants(item) {
      this.editedItem = item;
      // this.editedItem = Object.assign({}, item);
      this.showParticipantsDialog = true;
    },
    deleteItemConfirm() {
      this.users.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.showParticipantsDialog = false;
      this.editedEmail = '';
      this.$store.commit('emailResended', null);
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
    async saveEmail() {
      if (!this.editedItem || !this.editedItem._id) {
        return;
      }
      
      const currentEmail = this.getOriginalEmail(this.editedItem);
      if (this.editedEmail === currentEmail || this.editedEmail === '' || this.editedEmail === '-') {
        return; // No change
      }
      
      // Validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.editedEmail)) {
        this.SnackbarShow('Error', '', 'Ungültiges E-Mail-Format');
        this.editedEmail = currentEmail; // Reset to original
        return;
      }
      
      this.savingEmail = true;
      try {
        await axiosAuth.patch(`/events/entry/${this.editedItem._id}/email`, {
          email: this.editedEmail
        });
        
        // Refresh event to get updated data
        await this.refreshEvent();
        
        this.SnackbarShow('Success', '', 'E-Mail-Adresse erfolgreich aktualisiert');
      } catch (error) {
        console.error('Error updating email:', error);
        this.SnackbarShow('Error', '', 'Fehler beim Aktualisieren der E-Mail-Adresse');
        // Reset to original email on error
        this.editedEmail = currentEmail;
      } finally {
        this.savingEmail = false;
      }
    },
    getStatusColor(item) {
      if (!item) return 'grey';
      const payment = item.payment_id && item.payment_id.length > 0 ? item.payment_id[0] : null;
      if (!payment) return 'grey';
      if (payment.canceled) return 'error';
      if (payment.state === 'approved') return 'success';
      if (payment.state === 'created') return 'warning';
      return 'grey';
    },

    closeNoInvoice() {
      this.dialogNoInvoice = false;
      // this.$nextTick(() => {
      //   this.editedItem = Object.assign({}, this.defaultItem);
      // });
    },

    downloadInvoiceModal(item) {
      // Get payment object from payment_id array
      const payment = item.payment_id && item.payment_id.length > 0 ? item.payment_id[0] : null;
      if (!payment || !payment._id) {
        this.dialogNoInvoice = true;
      } else {
        // Use payment object (which has _id and invoice_nr) to download invoice
        this.downloadInvoice(payment);
      }
    },

    async save() {
      // if (this.editedIndex > -1) {
      //   Object.assign(this.users[this.editedIndex], this.editedItem);
      // } else {
      //   this.users.push(this.editedItem);
      // }
      this.saving = true;
      this.$emit('entry-updating', true);
      try {
        await this.updateEventEntry(this.editedItem);
        // Wait for the store to finish processing
        await this.$nextTick();
        this.$emit('entry-updated');
        this.close();
      } catch (error) {
        console.error('Error updating entry:', error);
        this.$emit('entry-update-error', error);
      } finally {
        this.saving = false;
        this.$emit('entry-updating', false);
      }
    },

    formatDate(dateString) {
      if (!dateString) return '-'
      return new Date(dateString).toLocaleDateString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    getInvoiceNumber(item) {
      const payment = item.payment_id && item.payment_id.length > 0 ? item.payment_id[0] : null;
      return payment ? (payment.invoice_nr || '-') : '-';
    },
    getPaymentMethod(item) {
      const payment = item.payment_id && item.payment_id.length > 0 ? item.payment_id[0] : null;
      if (!payment) return '-';
      
      if (payment.payment_method === 'pos') {
        const modeLabels = {
          'cash': 'POS: Bar',
          'electronic': 'POS: Elektronisch',
          'invoice': 'POS: Rechnung'
        };
        const mode = payment.payment_mode || 'Bar';
        return modeLabels[mode] || `POS: ${mode}`;
      } else {
        return 'PayPal';
      }
    },
    getSource(item) {
      const payment = item.payment_id && item.payment_id.length > 0 ? item.payment_id[0] : null;
      if (!payment || !payment.source) return '-';
      
      const sourceMap = {
        'pos': 'POS-Verkauf',
        'app': 'Ticket-App',
        'website': 'Website'
      };
      return sourceMap[payment.source] || payment.source;
    },
    getPaymentStatus(item) {
      const payment = item.payment_id && item.payment_id.length > 0 ? item.payment_id[0] : null;
      if (!payment) return '-';
      
      if (payment.transactions && payment.transactions[0] && payment.transactions[0].related_resources) {
        const sale = payment.transactions[0].related_resources[0].sale;
        if (sale && sale.state) {
          const stateMap = {
            'completed': 'Abgeschlossen',
            'pending': 'Ausstehend',
            'refunded': 'Erstattet',
            'partially_refunded': 'Teilweise erstattet'
          };
          return stateMap[sale.state] || sale.state;
        }
      }
      
      // Fallback: use payment state if available
      if (payment.state) {
        const stateMap = {
          'approved': 'Bestätigt',
          'created': 'Erstellt',
          'canceled': 'Storniert'
        };
        return stateMap[payment.state] || payment.state;
      }
      
      return '-';
    },
    getPaymentFirstName(item) {
      const payment = item.payment_id && item.payment_id.length > 0 ? item.payment_id[0] : null;
      if (!payment) return '-';
      
      // Use eventPayload.firstname (same as invoice generation)
      if (payment.eventPayload && payment.eventPayload.firstname) {
        return payment.eventPayload.firstname;
      }
      
      return '-';
    },
    getPaymentLastName(item) {
      const payment = item.payment_id && item.payment_id.length > 0 ? item.payment_id[0] : null;
      if (!payment) return '-';
      
      // Use eventPayload.lastname (same as invoice generation)
      if (payment.eventPayload && payment.eventPayload.lastname) {
        return payment.eventPayload.lastname;
      }
      
      return '-';
    },
    getOriginalEmail(item) {
      // Priority: eventEntry.email (the email that is actually used for sending)
      if (item.email) {
        return item.email;
      }
      
      // Fallback: payment.eventPayload.email
      const payment = item.payment_id && item.payment_id.length > 0 ? item.payment_id[0] : null;
      if (payment && payment.eventPayload && payment.eventPayload.email) {
        return payment.eventPayload.email;
      }
      
      return '-';
    },
    getPaymentEmail(item) {
      // If this is the currently edited item and we have an edited email, use that
      if (this.editedItem && this.editedItem._id && item._id && 
          this.editedItem._id.toString() === item._id.toString() && 
          this.editedEmail) {
        return this.editedEmail;
      }
      
      return this.getOriginalEmail(item);
    },
    getPaymentStreet(item) {
      const payment = item.payment_id && item.payment_id.length > 0 ? item.payment_id[0] : null;
      if (!payment) return '-';
      
      // Use eventPayload.street (same as invoice generation)
      if (payment.eventPayload && payment.eventPayload.street) {
        return payment.eventPayload.street;
      }
      
      return '-';
    },
    getPaymentNumber(item) {
      const payment = item.payment_id && item.payment_id.length > 0 ? item.payment_id[0] : null;
      if (!payment) return '-';
      
      // Use eventPayload.number (same as invoice generation)
      if (payment.eventPayload && payment.eventPayload.number) {
        return payment.eventPayload.number;
      }
      
      return '-';
    },
    getPaymentZip(item) {
      const payment = item.payment_id && item.payment_id.length > 0 ? item.payment_id[0] : null;
      if (!payment) return '-';
      
      // Use eventPayload.zip (same as invoice generation)
      if (payment.eventPayload && payment.eventPayload.zip) {
        return payment.eventPayload.zip;
      }
      
      // Try first participant zipcode as fallback
      if (payment.eventPayload && payment.eventPayload.participants && payment.eventPayload.participants.length > 0 && payment.eventPayload.participants[0].zipcode) {
        return payment.eventPayload.participants[0].zipcode;
      }
      
      return '-';
    },
    getPaymentCity(item) {
      const payment = item.payment_id && item.payment_id.length > 0 ? item.payment_id[0] : null;
      if (!payment) return '-';
      
      // Use eventPayload.city (same as invoice generation)
      if (payment.eventPayload && payment.eventPayload.city) {
        return payment.eventPayload.city;
      }
      
      // Try first participant city as fallback
      if (payment.eventPayload && payment.eventPayload.participants && payment.eventPayload.participants.length > 0 && payment.eventPayload.participants[0].city) {
        return payment.eventPayload.participants[0].city;
      }
      
      return '-';
    },
    getParticipantName(item) {
      if (item.participant_data && item.participant_data.name) {
        return item.participant_data.name;
      }
      return '-';
    },
    isEmailInvalid(item) {
      if (!item) return true;
      
      // If this is the currently edited item and we have an edited email, use that
      if (this.editedItem && this.editedItem._id && item._id && 
          this.editedItem._id.toString() === item._id.toString() && 
          this.editedEmail) {
        const email = this.editedEmail;
        if (!email) {
          return true;
        }
        // Validate edited email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
          return true; // Invalid format
        }
        // Check for temporary/invalid email patterns
        return email.includes('@temp.local') || email.includes('@temp.') || !email.includes('@');
      }
      
      // Try to get email from payment first, then fallback to item.email
      let email = this.getPaymentEmail(item);
      if (!email || email === '-') {
        email = item.email;
      }
      
      if (!email) {
        return true;
      }
      
      // Check for temporary/invalid email patterns
      return email.includes('@temp.local') || email.includes('@temp.') || !email.includes('@');
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  computed: {
    ...mapGetters(['updatingEvents']),
    formTitle() {
      return "Rechnungsdaten Anmelder";
    },
    pages() {
      return this.pagination.rowsPerPage
        ? Math.ceil(this.items.length / this.pagination.rowsPerPage)
        : 0;
    },
    // Ensure entries is always an array
    entriesArray() {
      if (!this.event || !this.event.entries) return [];
      return Array.isArray(this.event.entries) ? this.event.entries : [];
    },
    filteredEntries() {
      return this.entriesArray.filter((entry) =>
        this.filter != ''
          ? this.filter == 'Eingelöst'
            ? entry.redeemed == true
            : !entry.redeemed
          : true
      );
    },
  },
};
</script>
